import React, { useState, useEffect } from "react";
import axios from "axios";

import Location from "./picture/cioda.png";
import Sort from "./picture/Sort.png";
import Expand from "./picture/smanji.png";
import Search from "./picture/lupa.png";
import Phone from "./picture/telefon.png";
import Mail from "./picture/mail.png";
import LinkIcon from "./picture/Link.png";
import Share from "./picture/Share.png";
import Copy from "./picture/copy.png";
import Star from "./picture/star.png";
import Edit from "./picture/edit.png";
import Delete from "./picture/close.png";
import Message from "./picture/1.png";
import Pdf from "./picture/export.png";
import WebPrez from "./picture/webprez.png";
import Smanji from "./picture/smanji.png";
import Slanje from "./picture/slanje.png";
import Plus from "./picture/blackPlus.png"
import Email from "./picture/mail.png";

import "./singleProvider.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import ExportButton from "./ExportButton"; // Import the export button component


import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { Page, Text, View, Document, PDFDownloadLink, StyleSheet } from "@react-pdf/renderer";

function SingleProvider({ providerTypeId }) {
    const [providers, setProviders] = useState([]);
    const [isSorted, setIsSorted] = useState(false);
    const [expandedProviderId, setExpandedProviderId] = useState(null);
    const [showRegionAndCityButtons, setShowRegionAndCityButtons] = useState(false);
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const [selectedRegions, setSelectedRegions] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]);
    const [flashRegionId, setFlashRegionId] = useState(null);
    const [flashCity, setFlashCity] = useState(null);

    const [feedbackOpened, setFeedbackOpened] = useState(false);

    const regions = [
        { id: "Beogradski", name: "Beogradski okrug" },
        { id: "Nišavski", name: "Nišavski okrug" },
        { id: "Južnobački", name: "Južnobački okrug" },
        { id: "Zapadnobački", name: "Zapadnobački okrug" },
        { id: "Šumadijski", name: "Šumadijski okrug" },
    ];

    const citiesByRegion = {
        Beogradski: ["Belgrade", "Zemun", "Novi Beograd"],
        Nišavski: ["Niš", "Aleksinac", "Prokuplje"],
        Južnobački: ["Novi Sad", "Vrbas", "Bačka Palanka"],
        Zapadnobački: ["Sombor", "Kula", "Apatin"],
        Šumadijski: ["Kragujevac", "Aranđelovac", "Topola"],
    };


    const [showRegionDropdown, setShowRegionDropdown] = useState(false);
    const [showCityDropdown, setShowCityDropdown] = useState(false);
    const [visibleField, setVisibleField] = useState(null); // Tracks the currently visible field
    const [areAllExpanded, setAreAllExpanded] = useState(false);
    const [areAllCollapsed, setAreAllCollapsed] = useState(false);

    const [editingProvider, setEditingProvider] = useState(null);
    const [feedbackProvider, setFeedbackProvider] = useState(null);
    const [feedbackText, setFeedbackText] = useState("");

    const handleToggleFeedback = (providerId) => {
        setFeedbackOpened((prev) => (prev === providerId ? null : providerId));
    };

    const handleUpdateProvider = async () => {
        if (!editingProvider) return;
    
        try {
            const response = await axios.post(
                "https://data.nadzor.app/api/admin_panel/provider/update.php",
                editingProvider, // Send the full provider object
                { headers: { "Content-Type": "application/json" } }
            );
    
            if (response.data.status === 200) {
                alert("Provider updated successfully!");
                setEditingProvider(null); // Exit edit mode
            } else {
                alert("Failed to update provider: " + response.data.message);
            }
        } catch (error) {
            console.error("Error updating provider:", error);
            alert("An error occurred while updating the provider.");
        }
    };
    



    const handleEditOrFeedback = (provider) => {
        const loggedUserEmail = localStorage.getItem("email");

        if (loggedUserEmail && provider.emails?.includes(loggedUserEmail)) {
            setEditingProvider((prev) =>
                prev && prev.id === provider.id
                    ? null
                    : {
                        ...provider,
                        phones: provider.phones.length > 0 ? [...provider.phones] : [''],
                        emails: provider.emails.length > 0 ? [...provider.emails] : [''],
                        locations: provider.locations.length > 0 ? [...provider.locations] : [''],
                        links: provider.links.length > 0 ? [...provider.links] : [''],
                    }
            );
            setFeedbackProvider(null); // Close feedback if open
        } else {
            setFeedbackProvider((prev) =>
                prev && prev.id === provider.id ? null : provider
            );
            setEditingProvider(null); // Close edit if open
        }
    };




    const [buttonColor, setButtonColor] = useState(""); // State for button color
    const handleSubmitFeedback = async () => {
        if (!feedbackText.trim()) {
            setButtonColor("red"); // Change button to red
            setTimeout(() => setButtonColor(""), 500); // Reset after 500ms
            return;
        }

        const feedbackData = {
            pf_created_by: localStorage.getItem("email"), // Get user email from local storage
            pf_comment: feedbackText,
            provider_id: feedbackProvider.id, // The provider being reviewed
        };

        console.log("Sending feedback:", feedbackData); // Debugging log

        try {
            const response = await axios.post(
                "https://data.nadzor.app/api/admin_panel/provider/sendFeedback.php",
                feedbackData,
                {
                    headers: { "Content-Type": "application/json" }, // Ensure correct headers
                }
            );

            console.log("Server response:", response.data); // Log full response

            if (response.data.status === 201) {
                setButtonColor("green"); // Change button to green
                setTimeout(() => {
                    setButtonColor(""); // Reset color
                    setFeedbackText(""); // Clear input
                    setFeedbackProvider(null); // Close feedback form
                }, 500);
            } else {
                alert("Failed to submit feedback: " + response.data.message);
            }
        } catch (error) {
            console.error("Error submitting feedback:", error);
            alert("An error occurred while submitting feedback.");
        }
    };

    const utf8Encode = (str) => {
        return new TextDecoder("utf-8").decode(new TextEncoder().encode(str));
    };

    // const handleExportPdf = (provider) => {
    //     if (!provider) return;

    //     const doc = new jsPDF({
    //         orientation: "portrait",
    //         unit: "mm",
    //         format: "a4"
    //     });

    //     // ✅ Safe Encoding for Special Characters (Avoiding URI Error)
    //     const safeText = (text) => text ? new TextDecoder().decode(new TextEncoder().encode(text)) : "";

    //     // ✅ Set Document Title
    //     // ✅ Use a font that supports special characters
    // doc.setFont("courier", "bold");  // Change from "helvetica" to "courier"
    //     doc.setFontSize(18);
    //     doc.text(safeText(provider.name), 15, 20);

    //     doc.setFont("courier", "normal");
    //     doc.setFontSize(12);
    //     doc.text(`Description: ${safeText(provider.description)}`, 15, 30);
    //     doc.text(`Region: ${safeText(utf8Encode(provider.region))}`, 15, 40);
    //     doc.text(`City: ${safeText(provider.city)}`, 15, 50);

    //     // ✅ Add ALL Emails
    //     if (provider.emails.length > 0) {
    //         doc.text("Emails:", 15, 60);
    //         provider.emails.forEach((email, index) => {
    //             doc.text(`- ${email}`, 20, 70 + index * 7);
    //         });
    //     }

    //     // ✅ Add Phones
    //     if (provider.phones.length > 0) {
    //         doc.text("Phones:", 15, 90);
    //         provider.phones.forEach((phone, index) => {
    //             doc.text(`- ${phone}`, 20, 100 + index * 7);
    //         });
    //     }

    //     // ✅ Add WebP (Website URL)
    //     if (provider.website) {
    //         doc.text("Website:", 15, 120);
    //         doc.textWithLink(provider.website, 20, 130, { url: provider.website });
    //     }

    //     // ✅ Add Other Links
    //     if (provider.links.length > 0) {
    //         doc.text("Links:", 15, 140);
    //         provider.links.forEach((link, index) => {
    //             doc.textWithLink(`- ${link}`, 20, 150 + index * 7, { url: link });
    //         });
    //     }

    //     // ✅ Add Address Section with Clickable Google Maps Links
    //     if (provider.locations.length > 0) {
    //         doc.text("Addresses:", 15, 170);
    //         provider.locations.forEach((location, index) => {
    //             const googleMapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(location)}`;
    //             doc.textWithLink(`- ${safeText(location)}`, 20, 180 + index * 7, { url: googleMapsUrl });
    //         });
    //     }

    //     // ✅ Capture Maps and Add to PDF
    //     setTimeout(() => {
    //         captureGoogleMaps(provider, doc);
    //     }, 1000);
    // };


    // ✅ Capture Google Maps Screenshots and Add to PDF




    const handleExportPdf = async (provider) => {
        if (!provider) return;

        const pdfDoc = await PDFDocument.create();
        const page = pdfDoc.addPage([595, 842]); // A4 size
        const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

        const { width, height } = page.getSize();
        const fontSize = 14;

        page.drawText(provider.name, {
            x: 50,
            y: height - 50,
            size: fontSize,
            font: timesRomanFont,
            color: rgb(0, 0, 0),
        });

        page.drawText(`Region: ${provider.region}`, {
            x: 50,
            y: height - 80,
            size: fontSize,
            font: timesRomanFont,
            color: rgb(0, 0, 0),
        });

        page.drawText(`City: ${provider.city}`, {
            x: 50,
            y: height - 110,
            size: fontSize,
            font: timesRomanFont,
            color: rgb(0, 0, 0),
        });

        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${provider.name}.pdf`;
        link.click();
    };
    const captureGoogleMaps = (provider, doc) => {
        const mapContainer = document.createElement("div");
        mapContainer.style.display = "flex";
        mapContainer.style.flexWrap = "wrap";
        mapContainer.style.justifyContent = "center";
        mapContainer.style.width = "800px";
        mapContainer.style.background = "#fff";
        mapContainer.style.padding = "10px";
        mapContainer.style.position = "absolute";
        mapContainer.style.top = "-9999px"; // Hide it from view

        provider.locations.forEach((location, index) => {
            const mapDiv = document.createElement("div");
            mapDiv.style.width = provider.locations.length === 1 ? "100%" : "50%";
            mapDiv.style.height = "250px";
            mapDiv.style.margin = "5px";
            mapDiv.style.border = "1px solid #ccc";

            const iframe = document.createElement("iframe");
            iframe.src = `https://maps.google.com/maps?q=${encodeURIComponent(location)}&output=embed`;
            iframe.width = "100%";
            iframe.height = "100%";
            iframe.style.border = "0";

            mapDiv.appendChild(iframe);
            mapContainer.appendChild(mapDiv);
        });

        document.body.appendChild(mapContainer);

        setTimeout(() => {
            html2canvas(mapContainer, { useCORS: true }).then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                doc.addImage(imgData, "PNG", 10, 180, 190, 100);
                doc.save(`${provider.name}.pdf`);
                document.body.removeChild(mapContainer);
            });
        }, 3000); // Wait for maps to load properly
    };


    // ✅ Fetch Providers from API when `providerTypeId` changes
    useEffect(() => {

        localStorage.setItem("email", "administracija@komot.rs")

        if (!providerTypeId) return;

        const fetchProviders = async () => {
            try {
                const response = await axios.get(
                    `https://data.nadzor.app/api/admin_panel/provider/read.php?type_id=${providerTypeId}`
                );

                if (response.data.status === 200) {
                    setProviders(response.data.providers);
                } else {
                    console.error("Error fetching providers:", response.data.message);
                    setProviders([]);
                }
            } catch (error) {
                console.error("Error fetching providers:", error);
            }
        };

        fetchProviders();
    }, [providerTypeId]);

    const handleRegionClick = (regionId) => {
        const hasProviders = providers.some((provider) => provider.region === regionId);

        if (hasProviders) {
            if (selectedRegions.includes(regionId)) {
                setSelectedRegions((prev) => prev.filter((id) => id !== regionId));
                setSelectedCities((prev) =>
                    prev.filter((city) => !citiesByRegion[regionId].includes(city))
                );
            } else {
                setSelectedRegions((prev) => [...prev, regionId]);
            }
        } else {
            setFlashRegionId(regionId);
            setTimeout(() => setFlashRegionId(null), 500);
        }
    };

    const handleCityClick = (city) => {
        const hasProviders = providers.some((provider) => provider.city === city);

        if (hasProviders) {
            if (selectedCities.includes(city)) {
                setSelectedCities((prev) => prev.filter((c) => c !== city));
            } else {
                setSelectedCities((prev) => [...prev, city]);
            }
        } else {
            setFlashCity(city);
            setTimeout(() => setFlashCity(null), 500);
        }
    };


    const toggleProvider = (id) => {
        setExpandedProviderId((prevId) => (prevId === id ? null : id));
        setAreAllCollapsed(false); // If manually toggling, disable collapse-all
    };

    const handleCollapseAll = () => {
        setAreAllCollapsed((prev) => !prev);
        setAreAllExpanded(false); // Reset expand-all when collapsing all
        setExpandedProviderId(null); // Collapse all providers individually
    };

    const handleExpandAll = () => {
        setAreAllExpanded((prev) => !prev);
        setAreAllCollapsed(false); // Reset collapse-all when expanding all
        setExpandedProviderId(null); // Reset any manually expanded provider
    };


    // const updateInputValue = (field, rowIndex, colIndex, value) => {
    //     setEditingProvider((prev) => {
    //         const updatedField = [...prev[field]];
    //         updatedField[rowIndex][colIndex] = value;
    //         return { ...prev, [field]: updatedField };
    //     });
    // };
    const updateInputValue = (field, rowIndex, colIndex, value) => {
        setEditingProvider((prev) => {
            const updatedField = [...prev[field]];
            updatedField[rowIndex] = [...updatedField[rowIndex]]; // Copy the row
            updatedField[rowIndex][colIndex] = value; // Set new value
            return { ...prev, [field]: updatedField };
        });
    };

    const addTwoInputs = (field) => {
        setEditingProvider((prev) => ({
            ...prev,
            [field]: [...prev[field], '', ''], // Add two empty strings
        }));
    };


    const removeTwoInputs = (field) => {
        setEditingProvider((prev) => ({
            ...prev,
            [field]: prev[field].slice(0, Math.max(1, prev[field].length - 1)), // Ensures at least one remains
        }));
    };


    // ✅ Sort Providers
    const toggleSort = () => {
        setIsSorted((prev) => !prev);
        setProviders((prevProviders) => [...prevProviders].sort((a, b) =>
            isSorted ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
        ));
    };

    const toggleSearchInput = () => {
        setShowSearchInput((prev) => !prev);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const toggleRegionDropdown = () => {
        setShowRegionDropdown((prev) => !prev);
        setShowCityDropdown(false);
    };

    const toggleCityDropdown = () => {
        setShowCityDropdown((prev) => !prev);
        setShowRegionDropdown(false);
    };

    const filteredProviders = providers.filter((provider) => {
        const matchesSearch =
            !searchQuery ||
            provider.name.toLowerCase().includes(searchQuery) ||
            provider.description.toLowerCase().includes(searchQuery) ||
            provider.phones.some((phone) => phone.toLowerCase().includes(searchQuery)) ||
            provider.emails.some((email) => email.toLowerCase().includes(searchQuery)) ||
            provider.locations.some((location) => location.toLowerCase().includes(searchQuery)) ||
            provider.links.some((link) => link.toLowerCase().includes(searchQuery));

        const matchesRegion =
            selectedRegions.length === 0 || selectedRegions.includes(provider.region);

        const matchesCity =
            selectedCities.length === 0 || selectedCities.includes(provider.city);

        return matchesSearch && matchesRegion && matchesCity;
    });

    const handleShare = (provider) => {
        const shareText = `Check out this provider: ${provider.name}`;
        if (navigator.share) {
            navigator.share({
                title: 'Provider Details',
                text: shareText,
                url: provider.links[0] || window.location.href,
            }).catch((error) => console.error('Error sharing', error));
        } else {
            alert(`Share this: ${shareText}`);
        }
    };

    const handleCopy = (provider) => {
        const providerDetails = `
            Name: ${provider.name}
            Description: ${provider.description}
            Phones: ${provider.phones.join(', ')}
            Emails: ${provider.emails.join(', ')}
        `;
        navigator.clipboard.writeText(providerDetails).then(() => {
            alert('Provider details copied to clipboard!');
        }).catch((err) => console.error('Failed to copy: ', err));
    };

    const handleFavorite = (provider) => {
        const loggedUserEmail = localStorage.getItem("email"); // Get user email from localStorage

        if (loggedUserEmail && provider.emails?.includes(loggedUserEmail)) {
            // If user email matches any provider email, redirect to create.php
            window.open("https://web.nadzor.app/create.php", "_blank");
        } else if (provider.website) {
            // Otherwise, open the provider's website
            window.open(provider.website, "_blank");
        } else {
            alert("No website link available for this provider.");
        }
    };

    const saveProviderChanges = async (updatedProvider) => {
        try {
            const response = await axios.post(
                "https://data.nadzor.app/api/admin_panel/provider/update.php",
                updatedProvider
            );

            if (response.data.status === 200) {
                alert("Provider updated successfully!");

                // Refresh the providers list
                setProviders((prevProviders) =>
                    prevProviders.map((provider) =>
                        provider.id === updatedProvider.id ? updatedProvider : provider
                    )
                );

                // Close edit form
                setEditingProvider(null);
            } else {
                alert("Failed to update provider: " + response.data.message);
            }
        } catch (error) {
            console.error("Error updating provider:", error);
            alert("An error occurred while updating the provider.");
        }
    };
    // const updateArrayField = (field, index, value) => {
    //     setEditingProvider((prev) => {
    //         const updatedField = [...prev[field]];
    //         updatedField[index] = value;
    //         return { ...prev, [field]: updatedField };
    //     });
    // };

    const updateArrayField = (field, index, value) => {
        setEditingProvider((prev) => {
            const updatedField = [...prev[field]]; // Copy the array
            updatedField[index] = value; // Update the specific index
            return { ...prev, [field]: updatedField }; // Return the updated state
        });
    };


    const addField = (field) => {
        setEditingProvider((prev) => ({
            ...prev,
            [field]: [...prev[field], ''], // Adds an empty field
        }));
    };

    const removeField = (field, index) => {
        setEditingProvider((prev) => ({
            ...prev,
            [field]: prev[field].length > 1 ? prev[field].filter((_, i) => i !== index) : prev[field],
        }));
    };

    const handleCloseEdit = () => {
        setEditingProvider(null);
    }

    return (
        <div className="single-providers-container">
            {/* Edit Provider Form (Only If User Owns the Provider) */}
            {editingProvider ? (
                <>
                    <div className="edit-provider-form">
                        <div className="button-exit-edit">
                            <button onClick={handleCloseEdit} className="dos-btn-active">
                                <img src={Edit} alt="" />
                            </button>
                        </div>
                        {/* Name Input */}
                        <div className="name-input">
                            <label htmlFor="name">Naziv</label>
                            <input
                                type="text"
                                id="name"
                                value={editingProvider.name}
                                onChange={(e) => setEditingProvider({ ...editingProvider, name: e.target.value })}
                            />
                        </div>

                        {/* Description Input */}
                        <div className="desc-input">
                            <label htmlFor="desc">Opis</label>
                            <input
                                type="text"
                                id="desc"
                                value={editingProvider.description}
                                onChange={(e) => setEditingProvider({ ...editingProvider, description: e.target.value })}
                            />
                        </div>

                        {/* Phones Section */}
                        {/* Phones Section */}
                        {/* Phones Section */}
                        {/* Phones Section */}
                        {/* Phones Section */}
                        {/* Phones Section */}
                        <div className="phones-input">
                            <div className="phones-input-title">
                                <img src={Phone} alt="Add Phones Icon" />
                                <span>TELEFONI</span>
                            </div>
                            {Array.from({ length: Math.ceil(editingProvider.phones.length / 2) }).map((_, rowIndex) => {
                                const firstIndex = rowIndex * 2;
                                const secondIndex = firstIndex + 1;
                                const isLastRow = editingProvider.phones.length <= 2; // Only one row left?

                                return (
                                    <div className="single-phone" key={rowIndex}>
                                        <div className="single-phone-left">
                                            <input
                                                type="text"
                                                value={editingProvider.phones[firstIndex] || ''}
                                                onChange={(e) => updateArrayField('phones', firstIndex, e.target.value)}
                                            />
                                            <input
                                                type="text"
                                                value={editingProvider.phones[secondIndex] || ''}
                                                onChange={(e) => updateArrayField('phones', secondIndex, e.target.value)}
                                            />
                                        </div>
                                        <div className="single-phone-right">
                                            <button onClick={() => addField('phones')}>
                                                <img src={Plus} alt="Add Phones" />
                                            </button>
                                            <button
                                                onClick={() => removeField('phones', firstIndex)}
                                                disabled={isLastRow} // Disable when only one row left
                                                style={{ opacity: isLastRow ? 0.5 : 1 }}
                                            >
                                                <img src={Delete} alt="Remove Phones" />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>










                        {/* Emails Section */}
                        {/* Emails Section */}
                        {/* Emails Section */}
                        <div className="emails-input">
                            <div className="emails-input-title">
                                <img src={Email} alt="Add Emails Icon" />
                                <span>EMAIL ADRESE</span>
                            </div>
                            {Array.from({ length: Math.ceil(editingProvider.emails.length / 2) }).map((_, rowIndex) => {
                                const firstIndex = rowIndex * 2;
                                const secondIndex = firstIndex + 1;
                                const isLastRow = editingProvider.emails.length <= 2;

                                return (
                                    <div className="single-phone" key={rowIndex}>
                                        <div className="single-phone-left">
                                            <input
                                                type="text"
                                                value={editingProvider.emails[firstIndex] || ''}
                                                onChange={(e) => updateArrayField('emails', firstIndex, e.target.value)}
                                            />
                                            <input
                                                type="text"
                                                value={editingProvider.emails[secondIndex] || ''}
                                                onChange={(e) => updateArrayField('emails', secondIndex, e.target.value)}
                                            />
                                        </div>
                                        <div className="single-phone-right">
                                            <button onClick={() => addField('emails')}>
                                                <img src={Plus} alt="Add Emails" />
                                            </button>
                                            <button
                                                onClick={() => removeField('emails', firstIndex)}
                                                disabled={isLastRow}
                                                style={{ opacity: isLastRow ? 0.5 : 1 }}
                                            >
                                                <img src={Delete} alt="Remove Emails" />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>




                        {/* Locations Section */}
                        {/* Locations Section */}
                        {/* Locations Section */}
                        <div className="locations-input">
                            <div className="locations-input-title">
                                <img src={Location} alt="Add Locations Icon" />
                                <span>LOKACIJE</span>
                            </div>
                            {Array.from({ length: Math.ceil(editingProvider.locations.length / 2) }).map((_, rowIndex) => {
                                const firstIndex = rowIndex * 2;
                                const secondIndex = firstIndex + 1;
                                const isLastRow = editingProvider.locations.length <= 2;

                                return (
                                    <div className="single-phone" key={rowIndex}>
                                        <div className="single-phone-left">
                                            <input
                                                type="text"
                                                value={editingProvider.locations[firstIndex] || ''}
                                                onChange={(e) => updateArrayField('locations', firstIndex, e.target.value)}
                                            />
                                            <input
                                                type="text"
                                                value={editingProvider.locations[secondIndex] || ''}
                                                onChange={(e) => updateArrayField('locations', secondIndex, e.target.value)}
                                            />
                                        </div>
                                        <div className="single-phone-right">
                                            <button onClick={() => addField('locations')}>
                                                <img src={Plus} alt="Add Locations" />
                                            </button>
                                            <button
                                                onClick={() => removeField('locations', firstIndex)}
                                                disabled={isLastRow}
                                                style={{ opacity: isLastRow ? 0.5 : 1 }}
                                            >
                                                <img src={Delete} alt="Remove Locations" />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>





                        {/* Links Section */}
                        {/* Links Section */}
                        {/* Links Section */}
                        <div className="links-input">
                            <div className="links-input-title">
                                <img src={LinkIcon} alt="Add Links Icon" />
                                <span>LINKOVI</span>
                            </div>
                            {Array.from({ length: Math.ceil(editingProvider.links.length / 2) }).map((_, rowIndex) => {
                                const firstIndex = rowIndex * 2;
                                const secondIndex = firstIndex + 1;
                                const isLastRow = editingProvider.links.length <= 2;

                                return (
                                    <div className="single-phone" key={rowIndex}>
                                        <div className="single-phone-left">
                                            <input
                                                type="text"
                                                value={editingProvider.links[firstIndex] || ''}
                                                onChange={(e) => updateArrayField('links', firstIndex, e.target.value)}
                                            />
                                            <input
                                                type="text"
                                                value={editingProvider.links[secondIndex] || ''}
                                                onChange={(e) => updateArrayField('links', secondIndex, e.target.value)}
                                            />
                                        </div>
                                        <div className="single-phone-right">
                                            <button onClick={() => addField('links')}>
                                                <img src={Plus} alt="Add Links" />
                                            </button>
                                            <button
                                                onClick={() => removeField('links', firstIndex)}
                                                disabled={isLastRow}
                                                style={{ opacity: isLastRow ? 0.5 : 1 }}
                                            >
                                                <img src={Delete} alt="Remove Links" />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>



                        <div className="button-update-provider">
    <button onClick={handleUpdateProvider}>
        <img src={Slanje} alt="Update" />
    </button>
</div>

                    </div>
                </>
            ) : (
                <> {/* Add the next section here if needed */}

                    <div className="header-buttons">
                        <button className="dos-btn" onClick={() => setShowRegionAndCityButtons((prev) => !prev)}>
                            <img src={Location} alt="Location" />
                        </button>
                        <button className="dos-btn" onClick={toggleSort}>
                            <img src={Sort} alt="Sort" />
                        </button>
                        <button className="dos-btn" onClick={handleExpandAll}>
                            <img src={Smanji} alt="Collapse" />
                        </button>
                        <button className="dos-btn" onClick={toggleSearchInput}>
                            <img src={Search} alt="Search" />
                        </button>
                    </div>


                    {showRegionAndCityButtons && (
                        <div className="extra-buttons-row">
                            <button className="dos-btn" onClick={toggleRegionDropdown}>
                                Okrug
                            </button>
                            <button className="dos-btn" onClick={toggleCityDropdown}>
                                Gradovi
                            </button>
                        </div>
                    )}

                    {showRegionDropdown && (
                        <div className="region-dropdown">
                            <ul className="region-list">
                                {regions.map((region) => (
                                    <li
                                        key={region.id}
                                        className={`region-item ${selectedRegions.includes(region.id) ? "selected" : ""
                                            } ${flashRegionId === region.id ? "flash-red" : ""}`}
                                        onClick={() => handleRegionClick(region.id)}
                                    >
                                        {region.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {showCityDropdown && (
                        <div className="city-dropdown">
                            <ul className="city-list">
                                {selectedRegions.flatMap((regionId) =>
                                    citiesByRegion[regionId].map((city) => (
                                        <li
                                            key={city}
                                            className={`city-item ${selectedCities.includes(city) ? "selected" : ""
                                                } ${flashCity === city ? "flash-red" : ""}`}
                                            onClick={() => handleCityClick(city)}
                                        >
                                            {city}
                                        </li>
                                    ))
                                )}
                            </ul>
                        </div>
                    )}


                    {showSearchInput && (
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Search providers..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                                className="search-input"
                            />
                        </div>
                    )}
                    <div className="selected-filters">
                        <strong></strong> {selectedRegions.join(", ") || ""} <br />
                        <strong></strong> {selectedCities.join(", ") || ""}
                    </div>

                    {/* Providers List */}
                    <div className="providers-list">
                        {filteredProviders.length === 0 ? (
                            <p>No providers found.</p>
                        ) : (
                            filteredProviders.map((provider, index) =>
                                editingProvider && editingProvider.id !== provider.id ? null : (
                                    <div className="single-provider" key={provider.id}>
                                        {/* Provider Header */}
                                        <div
                                            className="provider-header"
                                            onClick={() => toggleProvider(provider.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="single-provider-name">
                                                <h3>
                                                    {!isSorted ? (
                                                        <strong>{`${index + 1}. ${provider.name}`}</strong>
                                                    ) : (
                                                        <strong>{`${filteredProviders.length - index}. ${provider.name}`}</strong>
                                                    )}
                                                </h3>
                                            </div>
                                            <div className="single-provider-desc">
                                                <span>{provider.description}</span>
                                                <a href="#">
                                                    <img src={Message} alt="Message" />
                                                </a>
                                            </div>
                                        </div>

                                        {/* Provider Details */}
                                        {(areAllExpanded || expandedProviderId === provider.id) && (
                                            <>
                                                {/* Phones Section */}
                                                {visibleField === 'phone' && provider.phones?.length > 0 && (
                                                    <div className="provider-group">
                                                        {provider.phones.map((phone, idx) => (
                                                            <div className="single-phone" key={idx}>
                                                                <span>{phone}</span>
                                                                <a href={`tel:${phone}`}>
                                                                    <img src={Phone} alt="Call" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Emails Section */}
                                                {visibleField === 'email' && provider.emails?.length > 0 && (
                                                    <div className="provider-group">
                                                        {provider.emails.map((email, idx) => (
                                                            <div className="single-email" key={idx}>
                                                                <span>{email}</span>
                                                                <a href={`mailto:${email}`}>
                                                                    <img src={Mail} alt="Email" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Address Section */}
                                                {visibleField === 'location' && provider.locations?.length > 0 && (
                                                    <div className="provider-group">
                                                        {provider.locations.map((loc, idx) => (
                                                            <div className="single-location" key={idx}>
                                                                <span>{loc}</span>
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    href={`https://www.google.com/maps?q=${encodeURIComponent(loc)}`}
                                                                >
                                                                    <img src={Location} alt="View on Map" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Links Section */}
                                                {visibleField === 'link' && provider.links?.length > 0 && (
                                                    <div className="provider-group">
                                                        {provider.links.map((link, idx) => (
                                                            <div className="single-link" key={idx}>
                                                                <span>{link}</span>
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    href={link}
                                                                >
                                                                    <img src={LinkIcon} alt="Visit Website" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Show All Details If No Filter */}
                                                {!visibleField && (
                                                    <>
                                                        <div className="provider-group">
                                                            {provider.phones.map((phone, idx) => (
                                                                <div className="single-phone" key={idx}>
                                                                    <span>{phone}</span>
                                                                    <a href={`tel:${phone}`}>
                                                                        <img src={Phone} alt="Call" />
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="provider-group">
                                                            {provider.emails.map((email, idx) => (
                                                                <div className="single-email" key={idx}>
                                                                    <span>{email}</span>
                                                                    <a href={`mailto:${email}`}>
                                                                        <img src={Mail} alt="Email" />
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="provider-group">
                                                            {provider.locations.map((loc, idx) => (
                                                                <div className="single-location" key={idx}>
                                                                    <span>{loc}</span>
                                                                    <a
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        href={`https://www.google.com/maps?q=${encodeURIComponent(loc)}`}
                                                                    >
                                                                        <img src={Location} alt="View on Map" />
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="provider-group">
                                                            {provider.links.map((link, idx) => (
                                                                <div className="single-link" key={idx}>
                                                                    <span>{link}</span>
                                                                    <a
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        href={link}
                                                                    >
                                                                        <img src={LinkIcon} alt="Visit Website" />
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {/* Provider Footer */}
                                        {(areAllExpanded || expandedProviderId === provider.id) && (
                                            <div className="button-row-footer">
                                                <button onClick={() => handleShare(provider)}>
                                                    <img src={Share} alt="Share" />
                                                </button>
                                                <button onClick={() => handleCopy(provider)}>
                                                    <img src={Copy} alt="Copy" />
                                                </button>
                                                <button onClick={() => handleFavorite(provider)} className="dos-btn">
                                                    <img src={WebPrez} alt="Visit Website" />
                                                </button>
                                                {(editingProvider || feedbackProvider) && editingProvider?.id !== provider.id && feedbackProvider?.id !== provider.id ? null : (
                                                    <button
                                                        className={`dos-btn ${(editingProvider?.id === provider.id || feedbackProvider?.id === provider.id) ? "dos-btn-active" : ""
                                                            }`}
                                                        onClick={() => handleEditOrFeedback(provider)}
                                                    >
                                                        <img
                                                            src={
                                                                provider.emails?.includes(localStorage.getItem("email"))
                                                                    ? Edit  // Always show Edit if user owns the provider
                                                                    : (feedbackProvider?.id === provider.id ? Message : Message) // Otherwise, show Message
                                                            }
                                                            alt={provider.emails?.includes(localStorage.getItem("email")) ? "Edit" : "Feedback"}
                                                        />
                                                    </button>
                                                )}

                                                {/* <button className="dos-btn" onClick={() => handleExportPdf(provider)}>
                                                <img src={Pdf} alt="Export to PDF" />
                                            </button> */}
                                                <ExportButton provider={provider} />

                                            </div>
                                        )}

                                        {/* Show Feedback Form if the user doesn't own the provider */}
                                        {feedbackProvider && feedbackProvider.id === provider.id && (
                                            <div className="feedback">
                                                <textarea
                                                    name="feedback"
                                                    id="feedback"
                                                    placeholder="Suggest changes..."
                                                    value={feedbackText}
                                                    onChange={(e) => setFeedbackText(e.target.value)}
                                                />
                                                <button
                                                    className="dos-btn"
                                                    onClick={handleSubmitFeedback}
                                                    style={{ backgroundColor: buttonColor }} // Apply color state
                                                >
                                                    <img src={Slanje} alt="Submit Feedback" />
                                                </button>

                                            </div>
                                        )}



                                        <hr />
                                    </div>


                                ))
                        )}
                    </div>
                </>)
            }
            {/* Header Buttons */}




        </div>
    );
}

export default SingleProvider;
